export default "__VITE_ASSET__DBwIyrpJ__"